import { useCallback, useMemo } from 'react';
import { useParams } from 'react-router';

import { RouteParams } from '@/routes';
import { useOpenCall } from '@/state';
import { Submission } from '@repo/api/open-calls/graphql';
import { getOpenCallTypeUiConfig } from './registry';
import { SubmissionWithTypedPayload } from './types';

export function useOpenCallUiConfig(openCallIdOverride?: string) {
  const { openCallId: routeOpenCallId } = useParams<RouteParams>();
  const openCallId = openCallIdOverride ?? routeOpenCallId ?? '';
  const { openCall, loading: isUiConfigLoading } = useOpenCall(openCallId);

  const uiConfig = useMemo(
    () => getOpenCallTypeUiConfig(openCall?.typeId),
    [openCall?.typeId],
  );

  const getCandidateDisplay = useCallback(
    (candidate: Submission) =>
      uiConfig.candidateCard.getDisplay(
        candidate as SubmissionWithTypedPayload,
      ),
    [uiConfig],
  );

  return {
    getCandidateDisplay,
    isUiConfigLoading,
    openCall,
    uiConfig,
  };
}
